import React, { Component } from 'react'
import { PropTypes } from 'prop-types'
import { Title } from 'components/layout'
import { Button } from 'components/misc'
// import { get } from 'lodash'

export default class ConfirmBox extends Component {
  static propTypes = {
    secondaryLabel: PropTypes.string,
    secondaryIntlKey: PropTypes.string,
    primaryLabel: PropTypes.string,
    primaryIntlKey: PropTypes.string,
    titleIntlKey: PropTypes.string,
    title: PropTypes.string,
    onClick: PropTypes.func.isRequired,
    onSecondaryClick: PropTypes.func.isRequired,
    data: PropTypes.object
  }

  static defaultProps = {
    secondaryLabel: 'Close',
    secondaryIntlKey: 'button.close',
    primaryLabel: 'Confirm',
    primaryIntlKey: 'button.confirm',
    title: 'Are you sure?',
    titleIntlKey: 'moduleTitle.are_you_sure'
  }

  state = {
    loading: false
  }

  handleMainActionClick = () => {
    const { data } = this.props

    this.setState({ loading: true })

    return Promise.resolve(this.props.onClick(data))
      .then(() => {
        this.setState({ loading: false })
      })
      .catch(() => {
        this.setState({ loading: false })
      })
  }

  render() {
    const {
      secondaryLabel,
      secondaryIntlKey,
      primaryLabel,
      primaryIntlKey,
      titleIntlKey,
      title
    } = this.props
    const { loading } = this.state

    return (
      <div>
        <div className="row">
          <Title h2 className="text--center" intlKey={titleIntlKey}>
            {title}
          </Title>
          <div className="col-xs-6">
            <Button
              type="button"
              secondary
              intlKey={secondaryIntlKey}
              onClick={this.props.onSecondaryClick}
            >
              {secondaryLabel}
            </Button>
          </div>
          <div className="col-xs-6 text--right">
            <Button
              type="button"
              intlKey={primaryIntlKey}
              onClick={this.handleMainActionClick}
              isLoading={loading}
            >
              {primaryLabel}
            </Button>
          </div>
        </div>
      </div>
    )
  }
}
